// const API_URL = "http://localhost:5010";
const API_URL = "http://13.127.13.91:5010";

const APP_NAME = "Jire Property";

const GOOGLE_MAPS_KEY = "AIzaSyCKnNtQpM3OdiJaEkClth5f6mWkHIiGZlA";
const APPLE_CLIENT_ID = "com.daftclone.daftclone";
const APPLE_REDIRECT_URI = "https://daftclone.vercel.app";

export default API_URL;
export { APP_NAME, GOOGLE_MAPS_KEY, APPLE_CLIENT_ID, APPLE_REDIRECT_URI };